import { MedicationRequestCompleteRequest } from "@shared/zod/schemas/requests/medicationRequest"
import { PageRequest } from "@shared/zod/schemas/requests/page"
import {
  MedicationDecisionEmailPreviewResponse,
  MedicationRequestDetailResponse,
  MedicationRequestPageResponse,
} from "@shared/zod/schemas/responses/medicationRequest"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const findAll = (query?: PageRequest): Promise<MedicationRequestPageResponse> => {
  return axiosAuth({
    url: "/medicationrequests",
    method: "get",
    params: query,
  }).then((resp) => resp.data)
}

export const get = (id: string): Promise<MedicationRequestDetailResponse> => {
  return axiosAuth({
    url: `/medicationrequests/${id}`,
    method: "get",
  }).then((resp) => resp.data)
}

/**
 * "Save & send": every line decided in one go. Final — the backend refuses a
 * second call for the same request.
 */
export const complete = (id: string, body: MedicationRequestCompleteRequest): Promise<void> => {
  return axiosAuth({
    url: `/medicationrequests/${id}/complete`,
    method: "post",
    data: body,
  }).then(() => undefined)
}

/** The decision email "save & send" would send for these decisions. Stores and sends nothing. */
export const previewComplete = (
  id: string,
  body: MedicationRequestCompleteRequest
): Promise<MedicationDecisionEmailPreviewResponse> => {
  return axiosAuth({
    url: `/medicationrequests/${id}/complete/preview`,
    method: "post",
    data: body,
  }).then((resp) => resp.data)
}
